module.exports = __webpack_public_path__ + "static/img/login-bg.d011ab5f.png";